import {get} from "lodash"

const isCycleCustom = (cycle) => {
  const interestContentId = get(cycle, "interest.contentId")
  return interestContentId === "insights.areaOfInterest.custom"
}

export default isCycleCustom
